
      import API from "!../../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../css-loader/dist/cjs.js??ruleSet[1].rules[2].oneOf[0].use[1]!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"src/style/box_text.css.ts.vanilla.css\",\"source\":\"LmJvMWhwdTAgewogIGJvcmRlcjogMXB4IHNvbGlkIHZhcigtLV8xajdycDU3MXQpOwogIGJhY2tncm91bmQtY29sb3I6IHZhcigtLV8xajdycDU3MXIpOwogIGNvbG9yOiB2YXIoLS1fMWo3cnA1NzIpOwogIGJvcmRlci1yYWRpdXM6IDhweDsKICBwYWRkaW5nOiAxMHB4IDE2cHggMTZweCAxNnB4Owp9\"}!./extracted.js";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../css-loader/dist/cjs.js??ruleSet[1].rules[2].oneOf[0].use[1]!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"src/style/box_text.css.ts.vanilla.css\",\"source\":\"LmJvMWhwdTAgewogIGJvcmRlcjogMXB4IHNvbGlkIHZhcigtLV8xajdycDU3MXQpOwogIGJhY2tncm91bmQtY29sb3I6IHZhcigtLV8xajdycDU3MXIpOwogIGNvbG9yOiB2YXIoLS1fMWo3cnA1NzIpOwogIGJvcmRlci1yYWRpdXM6IDhweDsKICBwYWRkaW5nOiAxMHB4IDE2cHggMTZweCAxNnB4Owp9\"}!./extracted.js";
       export default content && content.locals ? content.locals : undefined;
